'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Components


// Actions


// Utils


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _Button = require('../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _BoardSharingPopup = require('./BoardSharingPopup');

var _BoardSharingPopup2 = _interopRequireDefault(_BoardSharingPopup);

var _RootBoardSharingPopup = require('./RootBoardSharingPopup');

var _RootBoardSharingPopup2 = _interopRequireDefault(_RootBoardSharingPopup);

var _BoardWriteStatus = require('./BoardWriteStatus');

var _BoardWriteStatus2 = _interopRequireDefault(_BoardWriteStatus);

var _popupActions = require('../../../../components/popupPanel/popupActions');

var _permissionUtil = require('../../../../../common/permissions/permissionUtil');

var _boardSharingHelpers = require('./boardSharingHelpers');

var _sharingUtilSelector = require('./sharingUtilSelector');

require('./BoardSharingUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openPopupPanel: function openPopupPanel() {
            return dispatch((0, _popupActions.togglePopup)('sharing'));
        },
        openRootBoardTooltip: function openRootBoardTooltip() {
            return dispatch((0, _popupActions.togglePopup)('sharing-tooltip'));
        }
    };
};

var BoardSharingUtil = (_dec = (0, _reactRedux.connect)(_sharingUtilSelector.boardSharingUtilSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(BoardSharingUtil, _React$Component);

    function BoardSharingUtil() {
        _classCallCheck(this, BoardSharingUtil);

        var _this = _possibleConstructorReturn(this, (BoardSharingUtil.__proto__ || Object.getPrototypeOf(BoardSharingUtil)).call(this));

        _this.state = {
            downArrowPosition: {
                left: 0,
                width: 0
            }
        };

        _this.updateArrowState = _this.updateArrowState.bind(_this);
        return _this;
    }

    _createClass(BoardSharingUtil, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.props.popupOpen && nextProps.popupOpen) {
                this.updateArrowState();
            }
        }

        /**
         * Need to wait until after the component has updated so we can get the new position of the arrow.
         */
        /* eslint-disable react/no-did-update-set-state */

    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.popupOpen && this.props.sharedUserCount !== prevProps.sharedUserCount) {
                this.updateArrowState();
            }
        }
        /* eslint-enable react/no-did-update-set-state */

    }, {
        key: 'updateArrowState',
        value: function updateArrowState() {
            var arrowBoundingRect = this.refs.arrow.getBoundingClientRect();
            this.setState({
                downArrowPosition: {
                    left: arrowBoundingRect.left,
                    width: arrowBoundingRect.width
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                isRootBoard = _props.isRootBoard,
                userPermissions = _props.userPermissions,
                boardPermissions = _props.boardPermissions,
                openPopupPanel = _props.openPopupPanel,
                isMobileView = _props.isMobileView,
                openRootBoardTooltip = _props.openRootBoardTooltip;
            var downArrowPosition = this.state.downArrowPosition;


            if (!(0, _permissionUtil.canEditPermissions)(userPermissions)) {
                return _react2.default.createElement(
                    'div',
                    { className: 'BoardSharingUtil' },
                    _react2.default.createElement(_BoardWriteStatus2.default, this.props)
                );
            }

            var handleButtonClick = isRootBoard ? openRootBoardTooltip : openPopupPanel;

            var buttonTitle = isRootBoard ? 'Private' : (0, _boardSharingHelpers.utilSharedTitle)(boardPermissions, isMobileView);

            return _react2.default.createElement(
                'div',
                { className: 'BoardSharingUtil' },
                _react2.default.createElement(
                    _Button2.default,
                    { popupId: 'sharing', onClickFn: handleButtonClick },
                    _react2.default.createElement(
                        'div',
                        { className: 'button-content' },
                        _react2.default.createElement(
                            'span',
                            { className: 'header-util-text' },
                            buttonTitle
                        ),
                        _react2.default.createElement(
                            'span',
                            { ref: 'arrow', className: 'arrow' },
                            _react2.default.createElement(_Icon2.default, { name: 'menu-down-arrow' })
                        )
                    )
                ),
                isRootBoard ? _react2.default.createElement(_RootBoardSharingPopup2.default, this.props) : _react2.default.createElement(_BoardSharingPopup2.default, _extends({}, this.props, { downArrowPosition: downArrowPosition }))
            );
        }
    }]);

    return BoardSharingUtil;
}(_react2.default.Component)) || _class);


BoardSharingUtil.propTypes = {
    popupOpen: _propTypes2.default.bool,
    openPopupPanel: _propTypes2.default.func,
    openRootBoardTooltip: _propTypes2.default.func,
    children: _propTypes2.default.element,
    currentBoardId: _propTypes2.default.string,
    sharingContext: _propTypes2.default.object,
    isShared: _propTypes2.default.bool,
    isMobileView: _propTypes2.default.bool,
    isRootBoard: _propTypes2.default.bool,
    sharedUserCount: _propTypes2.default.number,
    boardPermissions: _propTypes2.default.object,
    userPermissions: _propTypes2.default.number,
    usersCurrentlyViewing: _propTypes2.default.object
};

exports.default = BoardSharingUtil;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/BoardSharingUtil.js
// module id = 784
// module chunks = 0